export enum SignalWizardStep {
    SOURCES = "SOURCES",
    DESTINATIONS = "DESTINATIONS",
    CREATE_TRACKER = "CREATE_TRACKER",
    SUCCESS = "SUCCESS",
}

/** Steps shown in the header stepper; `SUCCESS` is a terminal screen. */
export const STEPPER_STEPS = [
    SignalWizardStep.SOURCES,
    SignalWizardStep.DESTINATIONS,
    SignalWizardStep.CREATE_TRACKER,
];

export const STEPS = {
    [SignalWizardStep.SOURCES]: {
        key: SignalWizardStep.SOURCES,
        languageKey: "sources",
        label: "Sources",
    },
    [SignalWizardStep.DESTINATIONS]: {
        key: SignalWizardStep.DESTINATIONS,
        languageKey: "destinations",
        label: "Destinations",
    },
    [SignalWizardStep.CREATE_TRACKER]: {
        key: SignalWizardStep.CREATE_TRACKER,
        languageKey: "create_tracker",
        label: "Create Tracker",
    },
};

/** `{ [sourceId]: source_type_id }` */
export type SelectedSources = Record<string, number>;
